import React from 'react'

const Organization = () => {
  return (
    <main className="content-page">Organization</main>
  )
}

export default Organization